const KNOWN = new Set([
    'not_started',
    'drafting',
    'in_review',
    'final',
    'final_edited',
    'orphaned'
]);
/**
 * RFI question status, derived and never stored (WRT §3.6). zou computes it
 * (`RfiSectionView.question_status`, WRT-16); this mirror is the fallback for
 * views without it.
 */ export function rfiQuestionStatus(s) {
    if (s.questionStatus && KNOWN.has(s.questionStatus)) {
        return s.questionStatus;
    }
    if (s.orphanedAt) return 'orphaned';
    if (s.finalVersionId) {
        return s.finalRegionSha256 === s.contentRegionSha256 ? 'final' : 'final_edited';
    }
    if (s.reviewState === 'pending') return 'in_review';
    if (!s.anchorBookmark || s.contentWords <= 0) return 'not_started';
    return 'drafting';
}
export const QUESTION_STATUS_LABEL = {
    not_started: 'Not started',
    drafting: 'Drafting',
    in_review: 'In review',
    final: 'Final',
    final_edited: 'Edited after final',
    orphaned: 'Heading missing'
};
export const QUESTION_STATUS_BADGE = {
    not_started: 'neutral',
    drafting: 'warning',
    in_review: 'info',
    final: 'success',
    final_edited: 'warning',
    orphaned: 'danger'
};
const NAV_TONE = {
    not_started: 'neutral',
    drafting: 'warning',
    in_review: 'info',
    final: 'success',
    final_edited: 'warning',
    orphaned: 'danger'
};
/** Numbered-nav square tone: a missing owner overrides it to danger. */ export function questionNavTone(s) {
    if (!s.ownerUserId.trim()) return 'danger';
    return NAV_TONE[rfiQuestionStatus(s)];
}
